// extracted by mini-css-extract-plugin
export default {"root":"CreateCohort_root__I5hDD","dialog":"CreateCohort_dialog__6NEjr"};